import authActions from "../actions/authActions";
import { authService } from "../../services/authService";
import { GetFromUrl } from "../../utils/GetFromUrl";

function getUserInfoFromToken(token) {
    try {
        let roles = JSON.parse(atob(token.split(".")[1]));
        window.store.dispatch(authActions.setUserInfo(roles));
        /*    visibilityOperations.fetch();*/
    } catch (e) {
        window.store.dispatch(authActions.setUserInfo(null));
        /*    visibilityOperations.fetch();*/
    }
}

//window.onstorage = () => {
//    let token = window.localStorage.getItem("token");
//    if (!!token) {
//        window.location.href = "/#/";
//    }
//};

async function refreshToken() {
    if (!!window.store.getState().authReducer.isPending) {
        return;
    }

    window.store.dispatch(authActions.refreshTokenPending());

    try {
        let token = await authService.refreshToken(
            window.store.getState().authReducer.token.refresh_token
        );

        if (!!token && !token.error && token.status == 200) {
            window.store.dispatch(authActions.refreshTokenSuccess(token));
            localStorage.setItem("token", JSON.stringify(token));

            getUserInfoFromToken(token.access_token);
        } else {
            window.store.dispatch(authActions.refreshTokenError("error"));
        }
    } catch (e) {
        window.store.dispatch(authActions.refreshTokenError(e.message));
    }
}

function awaitTokenRefresh(func) {
    if (!!window.store.getState().authReducer.isPending) {
        window.setTimeout(awaitTokenRefresh, 100, func);
    } else {
        func();
    }
}

async function awaitTokenRefreshAsync(func) {
    if (!!window.store.getState().authReducer.isPending) {
        window.setTimeout(awaitTokenRefreshAsync, 100, func);
    } else {
        await func();
    }
}

function getToken() {
    return !!window.store.getState().authReducer.token
        ? window.store.getState().authReducer.token.access_token
        : null;
}

function logout() {
    return (dispatch) => {
        dispatch(authActions.refreshTokenSuccess(null));
        localStorage.removeItem("token");
        localStorage.removeItem("isLoggedIn")
    };
}

export const authOperations = {
    refreshToken,
    awaitTokenRefresh,
    awaitTokenRefreshAsync,
    getToken,
    logout,
    getUserInfoFromToken,
};
